import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Backdrop, Fade } from '@material-ui/core';
import Button from '../Buttons/Button';
import CloseButton from '../Buttons/CloseButton';
import fontFamily from '../../assets/css/fonts';
import color from '../../assets/css/colors';
import { listClearingFeeDetails } from '../../services/FeeClearingReportService';
import Table, { columnType } from '../../components/ClearingTable/Table';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 1500,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    '& div:nth-child(1)': {
      flex: 1,
    },
    '& div:nth-child(2)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {
          fill: color.primary.main,
        },
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 30px',
    maxHeight: 600,
    overflowY: 'auto',
    fontFamily: fontFamily.headers,
    color: color.default.main,
    '& p': {
      fontSize: 16,
      fontFamily: fontFamily.headers,
      fontWeight: 400,
      lineHeight: '26px',
      color: color.default.main,
      marginTop: 0,
    },
    '& hr': {
      margin: '30px 0px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: 25,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 'auto',
    },
  },
  closeButton: {
    '& button': {
      marginTop: '-4px !important',
    },
  },
  paper: {
    position: 'absolute',
  },
}));

// Table Settings
const columns = [
  {
    name: 'correspondent',
    label: 'Correspondent',
  },
  {
    name: 'accountNo',
    label: 'Account No',
  },
  {
    name: 'branch',
    label: 'Branch',
  },
  {
    name: 'rep',
    label: 'Rep',
  },
  {
    name: 'masterAccountNo',
    label: 'Master Account No',
  },
  {
    name: 'month',
    label: 'Month',
  },
  {
    name: 'year',
    label: 'Year',
  },
  {
    name: 'recurringFee',
    label: 'Recurring Fee',
    type: columnType.amount,
    addFooter: true,
  },
  {
    name: 'qty',
    label: 'Qty',
    type: columnType.quantity,
  },
  {
    name: 'rate',
    label: 'Rate',
    type: columnType.price,
  },
  {
    name: 'grossAmt',
    label: 'Gross Amount',
    type: columnType.amount,
    addFooter: true,
  },
  {
    name: 'minCharge',
    label: 'Minimum Charge',
    type: columnType.amount,
    addFooter: true,
  },
  {
    name: 'chargeBy',
    label: 'Charge By',
  },
  {
    name: 'side',
    label: 'Side',
  },
  {
    name: 'minFee',
    label: 'Minimum Fee',
    type: columnType.amount,
  },
  {
    name: 'contraAccountNo',
    label: 'Contra Account No',
  },
  {
    name: 'contraCorrespondent',
    label: 'Contra Correspondent',
  },
  {
    name: 'symbol',
    label: 'Symbol',
  },
  {
    name: 'orderNo',
    label: 'Order No',
  },
  {
    name: 'compressType',
    label: 'Compress Type',
  },
  {
    name: 'a-selectAll',
    label: 'Select All',
    options: {
      display: true,
      print: false,
      download: false,
      filter: false,
      setCellHeaderProps: () => ({
        style: {
          width: '0px',
          display: 'table-cell',
          padding: 0,
          pointerEvents: 'none',
          fontSize: 0,
        },
      }),
    },
  },
];

const options = {
  responsive: 'standard',
  selectableRows: 'none',
};
// End Table Settings

export default function FeeClearingModal(props) {
  const classes = useStyles();
  const [rows, setRows] = React.useState([]);

  const { open, close } = props;
  useEffect(() => {
    async function init() {
      let value = props.data;

      const data = await listClearingFeeDetails(value);

      setRows(data.clearingFeeDetailsList);
    }

    init();
    // eslint-disable-next-line
  }, []);

  const handleClose = () => {
    close();
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={close}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <div style={{ width: 1500 }}>
          <div className={classes.modalHeader}>
            <div></div>
            <div className={classes.closeButton}>
              <CloseButton onClick={handleClose} />
            </div>
          </div>
          <div className={classes.modalBody}>
            <div>
              <Table
                title={'Recurring Fee Details'}
                data={rows}
                columns={columns}
                options={options}
              />
            </div>
          </div>
          <div className={classes.modalFooter}>
            <Button label="Close" onClick={handleClose} />
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
